export default "__VITE_ASSET__Dtg4P5Kt__"